/* eslint-disable global-require */
import * as React from "react";
import {registerStructure} from "@energylab/shared-components/modules/register/registerForm/config";
import {contactConfig} from "@energylab/shared-components/constants/config/contactConfig";
import {galleryConfig} from "@energylab/shared-components/constants/config/galleryConfig";
import {profileConfig} from "@energylab/shared-components/constants/config/profileConfig";
import {profileStructure} from "@energylab/shared-components/components/profile/profileForm/config";
import {resetPasswordConfig} from "@energylab/shared-components/constants/config/resetPasswordConfig";
import {whiteListSignUpConfig} from "@energylab/shared-components/constants/config/whiteListSignUpConfig";
import {nationalities} from "@energylab/shared-components/constants/nationalities";
import {ConfigReducerState} from "@energylab/shared-components/redux/reducers/configReducer";
import {getBrowserLocale} from "@energylab/shared-components/utils/browserLocale";
import {FormatMessage} from "@energylab/shared-components/components/formatMessage/formatMessage";
import * as environment from "environment";

const locales = ["nl", "en"];
const defaultLocale = "en";
profileConfig.requiredProfileFields = [
    "givenName",
    "familyName",
    "birthDate",
    "sex",
    "unit"
];


const entities = [
    {
        value: "Belgium", // OK
        label: "Belgium", // OK
        children: [
            {label: "Kuehne+Nagel NV", value: "Kuehne+Nagel NV"},
            {label: "Kuehne+Nagel Logistics NV", value: "Kuehne+Nagel Logistics NV"},
            {label: "Logistics Kontich BV", value: "Logistics Kontich BV"},
            {label: "Kuehne+Nagel Fullfillment NV", value: "Kuehne+Nagel Fullfillment NV"},
            {label: "Nacora Insurance Brokers NV", value: "Nacora Insurance Brokers NV"}
        ]
    }, {
        value: "Luxemburg",
        label: "Luxemburg",
        children: [
            {label: "Kuehne+Nagel s.a.r.l. - CELU 16", value: "Kuehne+Nagel s.a.r.l. - CELU 16"},
            {label: "Nacora s.r.l.", value: "Nacora s.r.l."},
            {label: "Kuehne+Nagel AG Luxembourg", value: "Kuehne+Nagel AG Luxembourg"},
            {
                label: "Kuehne+Nagel Beteiligungs-Aktiengesellschaft S.A.",
                value: "Kuehne+Nagel Beteiligungs-Aktiengesellschaft S.A."
            },
            {label: "Kuehne+Nagel investments s.a.r.l.", value: "Kuehne+Nagel investments s.a.r.l."}
        ]
    }, {
        value: "Netherlands",
        label: "Netherlands",
        children: [
            {label: "Kuehne+Nagel NV", value: "Kuehne+Nagel NV"},
            {label: "Nacora Assurantiekantoor BV", value: "Nacora Assurantiekantoor BV"},
            {label: "Kuehne+Nagel Logistics BV", value: "Kuehne+Nagel Logistics BV"},
            {label: "Kuehne-Nagel Investments BV", value: "Kuehne-Nagel Investments BV"}
        ]
    }
];

const locations = [
    {
        value: "Belgium", // OK
        label: "Belgium", // OK
        children: [
            {label: "Klaus-Michael Kuehnelaan 8. 2440, Geel", value: "Klaus-Michael Kuehnelaan 8. 2440, Geel"},
            {label: "Borsbeeksebrug 30/1. 2600, Antwerp", value: "Borsbeeksebrug 30/1. 2600, Antwerp"},
            {label: "Lossingstraat 7, Beringen", value: "Lossingstraat 7, Beringen"},
            {
                label: "Bedrijvenzone Machelen Cargo 833. 1830, Machelen",
                value: "Bedrijvenzone Machelen Cargo 833. 1830, Machelen"
            },
            {label: "Eindhoutseheide 1, 2430, Laakdal", value: "Eindhoutseheide 1, 2430, Laakdal"},
            {
                label: "Avenue du parc industriel 213, 4041, Herstal",
                value: "Avenue du parc industriel 213, 4041, Herstal"
            },
            {label: "Mechelsesteenweg 4. 1910, Kampenhout", value: "Mechelsesteenweg 4. 1910, Kampenhout"},
            {label: "Industrieweg 16c, 3190, Boortmeerbeek", value: "Industrieweg 16c, 3190, Boortmeerbeek"},
            {label: "1 Neerveld, Kontich", value: "1 Neerveld, Kontich"},
            {
                label: "Rue-du-Trilogiport 4 4681, Liege Hermalle-sous-Argenteau",
                value: "Rue-du-Trilogiport 4 4681, Liege Hermalle-sous-Argenteau"
            },
            {label: "Tessenderlo - Havenlaan 10", value: "Tessenderlo - Havenlaan 10"},
            {label: "Industrieweg 59, Tessenderlo-Ham", value: "Industrieweg 59, Tessenderlo-Ham"},
            {label: "Rue de Capilone 6, 6220, Fleurus", value: "Rue de Capilone 6, 6220, Fleurus"},
            {
                label: "Rue-du-Trilogiport 6 4681, Liege Hermalle-sous-Argenteau Hall 1A",
                value: "Rue-du-Trilogiport 6 4681, Liege Hermalle-sous-Argenteau Hall 1A"
            }
        ]
    }, {
        value: "Luxemburg",
        label: "Luxemburg",
        children: [
            {label: "Luxair Cargo Center, 1360, Luxemburgo", value: "Luxair Cargo Center, 1360, Luxemburgo"},
            {
                label: "1 Rue Edmond Reuter, 5326 Contern, Luxemburgo",
                value: "1 Rue Edmond Reuter, 5326 Contern, Luxemburgo"
            },
            {label: "2 allée Klaus, 5324 Contern, Luxemburgo", value: "2 allée Klaus, 5324 Contern, Luxemburgo"}
        ]
    }, {
        value: "Netherlands",
        label: "Netherlands",
        children: [
            {
                label: "Boompjes 40, 3011 XB Rotterdam, The Netherlands",
                value: "Boompjes 40, 3011 XB Rotterdam, The Netherlands"
            },
            {label: "Marshallweg 1, 5466 AH, Veghel", value: "Marshallweg 1, 5466 AH, Veghel"},
            {label: "Marshallweg 2, 5466 AJ, Veghel", value: "Marshallweg 2, 5466 AJ, Veghel"},
            {label: "Eisenhowerweg 15, 5466 AB, Veghel", value: "Eisenhowerweg 15, 5466 AB, Veghel"},
            {label: "Kennedylaan 19, 5466 AA, Veghel", value: "Kennedylaan 19, 5466 AA, Veghel"},
            {label: "Kennedylaan 20, 5466 AA, Veghel", value: "Kennedylaan 20, 5466 AA, Veghel"},
            {label: "Sojadijk 4, 5704 RL, Helmond", value: "Sojadijk 4, 5704 RL, Helmond"},
            {label: "Transitoweg 1, 4782 SM, Moerdijk", value: "Transitoweg 1, 4782 SM, Moerdijk"},
            {label: "Laan van Ruyven 1, 2645 EE, Delfgauw", value: "Laan van Ruyven 1, 2645 EE, Delfgauw"},
            {label: "Holtum-Noordweg 47, 6121 RE, Born", value: "Holtum-Noordweg 47, 6121 RE, Born"},
            {label: "Kleine Steng 10, 1551 NC, Westzaan", value: "Kleine Steng 10, 1551 NC, Westzaan"},
            {label: "Impact 79, 6921 RZ, Duiven", value: "Impact 79, 6921 RZ, Duiven"},
            {label: "Siriusstraat 5,5015 BT, Tilburg", value: "Siriusstraat 5,5015 BT, Tilburg"},
            {label: "Lippestraat 15, 8028 PS, Zwolle", value: "Lippestraat 15, 8028 PS, Zwolle"},
            {label: "Atoomweg 111, 3542 AB, Utrecht", value: "Atoomweg 111, 3542 AB, Utrecht"},
            {label: "Atoomweg 113, 3542 AB, Utrecht", value: "Atoomweg 113, 3542 AB, Utrecht"},
            {label: "Atoomweg 115, 3542 AB, Utrecht", value: "Atoomweg 115, 3542 AB, Utrecht"},
            {label: "Pudongweg 1, 1437 EM, Rozenburg", value: "Pudongweg 1, 1437 EM, Rozenburg"},
            {label: "De Diepert 5, 4004 MA, Tiel", value: "De Diepert 5, 4004 MA, Tiel"},
            {label: "Kronosstraat 1, 5048 CE, Tilburg", value: "Kronosstraat 1, 5048 CE, Tilburg"},
            {label: "De Afslag 7, 7833 HW, Nieuw-Amsterdam", value: "De Afslag 7, 7833 HW, Nieuw-Amsterdam"},
            {label: "Verhuellweg 56984 AA Doesburg", value: "Verhuellweg 56984 AA Doesburg"},
            {label: "Legmeerdijk 313, 1431 GB, Aalsmeer", value: "Legmeerdijk 313, 1431 GB, Aalsmeer"},
            {label: "Hoekwei 6, 4004 LX, Tiel", value: "Hoekwei 6, 4004 LX, Tiel"},
            {
                label: "Butaanweg 5c Haven 3005, 3196 KC, Vondelingenplaat R'dam",
                value: "Butaanweg 5c Haven 3005, 3196 KC, Vondelingenplaat R'dam"
            },
            {label: "Anchoragelaan 40, 1118 LD, Schiphol", value: "Anchoragelaan 40, 1118 LD, Schiphol"},
            {label: "Basisweg 50 B, 1951 NE, Velsen-Noord", value: "Basisweg 50 B, 1951 NE, Velsen-Noord"},
            {label: "Verhuellweg 5, 6984 AA, Doesburg", value: "Verhuellweg 5, 6984 AA, Doesburg"},
            {label: "Airbuslaan 2, 1119 MA, Schiphol-Rijk", value: "Airbuslaan 2, 1119 MA, Schiphol-Rijk"}
        ]
    }
]

const companies = [
    {
        label: "Energy Lab",
        value: "Energy Lab"
    },
    {
        label: "Aptus",
        value: "Aptus"
    },
    {
        label: "Nortal",
        value: "Nortal"
    },
    {
        label: "PwrTeams",
        value: "PwrTeams"
    },
    {
        label: "Skelia",
        value: "Skelia"
    },
    {
        label: "Golazo",
        value: "Golazo"
    }
];

const costCenters = [
    {
        label: "Air Logistics",
        value: "Air Logistics",
    },
    {
        label: "Contract Logistics",
        value: "Contract Logistics",
    },
    {
        label: "Customs",
        value: "Customs",
    },
    {
        label: "DSM",
        value: "DSM",
    },
    {
        label: "Finance",
        value: "Finance",
    },
    {
        label: "Human Resources",
        value: "Human Resources",
    },
    {
        label: "Insurance Brokers",
        value: "Insurance Brokers",
    },
    {
        label: "Integrated Logistics",
        value: "Integrated Logistics",
    },
    {
        label: "IT",
        value: "IT",
    },
    {
        label: "Legal",
        value: "Legal",
    },
    {
        label: "National Management",
        value: "National Management",
    },
    {
        label: "Other",
        value: "Other",
    },
    {
        label: "Project Logistics",
        value: "Project Logistics",
    },
    {
        label: "QSHE",
        value: "QSHE",
    },
    {
        label: "Road Logistics",
        value: "Road Logistics",
    },
    {
        label: "Sales",
        value: "Sales",
    },
    {
        label: "Sea Logistics",
        value: "Sea Logistics",
    }
]


// TODO: Change company logo
export const companyLogo = "https://res.cloudinary.com/energylab/image/upload/v1757688719/Kuehne%20Nagel/kn_logo_standard_positive_rgb.png";

export const config: ConfigReducerState = {
    mustAcceptPolicies: ["privacy"],
    profileConfig: {
        ...profileConfig,
        structure: {
            ...profileStructure,
            formElements: [
                ...profileStructure.formElements.filter(element => element.title !== 'auth.fields.country'),
                {
                    title: "auth.fields.country",
                    type: "select",
                    options: [
                        {
                            code: "BEL",
                            name: "Belgian"
                        },
                        {
                            code: "LU",
                            name: "Luxemburg"
                        },
                        {
                            code: "NL",
                            name: "Netherlands"
                        }
                    ].map(nat => (
                        {
                            title: <FormatMessage
                                id={`country.${nat.code}`}
                            />,
                            value: nat.code
                        }
                    )),
                    hide: false,
                    property: "country",
                    required: true
                },
                {
                    title: "auth.fields.entity",
                    type: "cascader",
                    options: entities,
                    property: "entity",
                    required: true
                },
                {
                    title: "auth.fields.location",
                    type: "cascader",
                    options: locations,
                    property: "location",
                    required: true
                },
                {
                    title: "auth.fields.cost_center",
                    type: "select",
                    options: costCenters,
                    property: "cost_center",
                    required: true
                },
                {
                    title: "auth.fields.delivery_address",
                    type: "text",
                    property: "delivery_address",
                    required: true
                },
            ]
        }
    },
    registerConfig: {
        backgroundImage: "https://res.cloudinary.com/energylab/image/upload/v1561558301/generic-v2/authbg.jpg",
        requireEmailValidation: false,
        structure: registerStructure
    },
    resetPasswordConfig,
    galleryConfig,
    ambassadorSettingsConfig: {
        enableRelive: false,
        enableComments: true
    },
    socialConfig: {
        disableInstagram: false,
        disableTwitter: false,
        disableFacebook: false,
        disableLinkedIn: false,
        disableOnChallenCard: false,
        hideFacebookOnCommunity: false,
        hideTwitterOnCommunity: false,
        hideInstagramOnCommunity: false,
        hideLinkedInOnCommunity: true
    },
    dashboardPlacesConfig: {
        articles: [],
        benefits: [],
        challenges: [],
        events: [],
        gallery: [],
        homePage: ["dashboard", "home"],
        leaderBoard: [],
        mySpace: [],
        mySpaceActivities: [],
        profile: [],
        webShop: [],
        contact: ["contact_header"]
    },
    ambassadorImage: "",
    auth: {
        facebookRedirect: environment.auth.facebook,
        googleRedirect: environment.auth.google,
        anonymousToken: environment.anonymousToken
    },
    commentsConfig: {
        disabled: false,
        autoShowSubComments: false,
        autoShowInput: false
    },
    eventsConfig: {
        defaultView: "list",
        viewOptions: []
    },
    contentConfig: {
        showAuthor: true,
        useThemes: true,
        previewType: "card",
        enablePageBanner: true,
        pageBannerImage: "https://res.cloudinary.com/energylab/image/upload/v1561558218/generic-v2/bannerimage.jpg",
        pageBannerOverlay: true,
        alignment: "left"
    },
    contactConfig: {
        imageUrl: "https://res.cloudinary.com/energylab/image/upload/v1561723053/generic-v2/contactbg.jpg",
        subjectOptions: [
            {key: "1", value: "option1"},
            {key: "2", value: "option2"}
        ],
        siteKey: contactConfig.siteKey
    },
    companyLogo,
    companyName: "Energy Lab",
    defaultTimezone: "Europe/Brussels",
    defaultCountry: "Belgium",
    defaultNationality: "BEL",
    coinsConfig: {
        enabled: false,
        coinName: "coin"
    },
    likesConfig: {
        disabled: false
    },
    webshopConfig: {
        enabled: false,
        shopName: ""
    },
    notificationsConfig: {
        enabled: false
    },
    jumbotronImage: "",
    localeDateFormat: "DD/MM/YYYY",
    routeConfig: {
        locales,
        defaultLocale,
        redirects: [],
        hideNavigationWhenLoggedOut: true
    },
    nationalities,
    selectedLanguage: getBrowserLocale(defaultLocale, locales),
    seo: {
        pageTitle: "Energy Lab generic platform V2",
        title: {
            nl: "Energy Lab",
            fr: "Energy Lab",
            en: "Energy Lab"
        },
        description: {
            nl: "",
            fr: "",
            en: ""
        },
        image: "",
        site: ""
    },
    uploadPreset: "development",
    newUsersConfig: {
        enabled: false,
        hasListOfNewUsers: false
    },
    leaderboardConfig: {
        pageSize: 10
    },
    socialShareConfig: {
        enabled: true,
        copyClipboardEnabled: false,
        shareWithEmail: {
            enabled: false
        }
    },
    whiteListSignUpConfig: {
        enabled: false,
        imageUrl: "https://res.cloudinary.com/energylab/image/upload/v1561723053/generic-v2/contactbg.jpg",
        subjectOptions: [],
        siteKey: whiteListSignUpConfig.siteKey
    },
    providers: []
};
